/**
 * Утилиты для работы с цветами
 */

/**
 * Преобразует hex цвет в RGB
 * @param {string} hex - hex цвет (например, '#ffffff' или 'ffffff')
 * @returns {object} RGB объект {r, g, b}
 */
function hexToRgb(hex) {
  // Убираем # если есть
  hex = hex.replace('#', '');
  
  // Парсим hex
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  
  return { r, g, b };
}

/**
 * Вычисляет яркость цвета по формуле W3C
 * @param {string} hex - hex цвет
 * @returns {number} яркость от 0 до 255
 */
function getLuminance(hex) {
  const { r, g, b } = hexToRgb(hex);
  
  // Формула W3C для вычисления яркости
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b);
  return luminance;
}

/**
 * Определяет, нужен ли темный текст для данного фонового цвета
 * @param {string} hex - hex цвет фона
 * @returns {boolean} true если нужен темный текст
 */
function shouldUseDarkText(hex) {
  if (!hex) return false;
  
  const luminance = getLuminance(hex);
  // Если яркость больше 128, то фон светлый и нужен темный текст
  return luminance > 128;
}

/**
 * Получает контрастный цвет текста для заданного фона
 * @param {string} hex - hex цвет фона
 * @returns {string} 'dark' или 'light'
 */
function getContrastTextColor(hex) {
  return shouldUseDarkText(hex) ? 'dark' : 'light';
}

/**
 * Получает стили для тега с учетом контрастности
 * @param {string} backgroundColor - hex цвет фона
 * @returns {object} объект со стилями
 */
function getTagStyles(backgroundColor) {
  if (!backgroundColor) {
    return {
      backgroundColor: '#f5f5f5',
      color: '#000000',
      border: '1px solid #d9d9d9'
    };
  }

  const useDarkText = shouldUseDarkText(backgroundColor);
  
  // Для светлых цветов добавляем черную рамку для лучшей видимости
  const borderColor = useDarkText ? '#000000' : backgroundColor;
  
  return {
    backgroundColor: backgroundColor,
    color: useDarkText ? '#000000' : '#ffffff',
    border: `1px solid ${borderColor}`,
    // Добавляем небольшой box-shadow для светлых цветов для дополнительного выделения
    boxShadow: useDarkText ? '0 1px 2px rgba(0, 0, 0, 0.1)' : 'none'
  };
}

export {
  hexToRgb,
  getLuminance,
  shouldUseDarkText,
  getContrastTextColor,
  getTagStyles
};
